import { useHistory, useLocation, useParams } from 'react-router-dom';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import useUserContext from '../../../hooks/useUserContext';
import useAPI from '../../../hooks/useAPI';
import { getMngData, getPeriodsData, _default } from '../../project/helpers/passport';
import PolicyProjectPassportEdit from './PassportEdit';
import PolicyProjectPassportRead from './PassportRead';
import {checkParamExists} from "../../../helpers/location";

export default function PolicyProjectPassport() {
  let { policyId, projId } = useParams();
  projId = projId && projId.split('?')[0]
  const history = useHistory();
  const location = useLocation();
  const userCtx = useUserContext();
  const api = useAPI();
  const [mngData, setMngData] = useState(_default.mngData);
  const [periods, setPeriods] = useState([]);
  const [isCheckedLatestVersion, setIsCheckedLatestVersion] = useState(false);
  const [isLatestVersion, setIsLatestVersion] = useState(false);
  const [isLoadingNewVersion, setIsLoadingNewVersion] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const isLinkedFromHistory = useRef(checkParamExists(location,'isHistory=1'))

  const isNewProject = useMemo(() => projId === 'new', [projId]);

  const recentVersionFallback = (idRecentVersion) => {
    history.push(`/policies/${policyId}/projs/${idRecentVersion}`);
  };

  useEffect(async () => {
    const responseMngData = await getMngData(api);
    setMngData(responseMngData);
    const responsePeriods = await getPeriodsData(api);
    setPeriods(responsePeriods);
  }, []);

  useEffect(async () => {
    if (location.search.includes('edit=1')) setIsEditMode(true);
    else setIsEditMode(false);
  }, [location.search]);

  useEffect(async () => {

    if (projId !== 'new') {
      const resp = await api.get(`/projs/${projId}/latest`);
      setIsLatestVersion(resp.id === resp.latestId);
      if (!resp.error && resp.id !== resp.latestId && (location.state === undefined || !location.state?.showOldVersion) && !isLinkedFromHistory.current) {
        recentVersionFallback(resp.latestId);
      }
      setIsCheckedLatestVersion(true);
    } else {
      setIsCheckedLatestVersion(true);
      setIsLatestVersion(true);
    }
  }, [projId]);

  const apiInitNewVersion = async () => {
    const newProj = await api.post(`/projs/${projId}/initNewVersion`);
    if (newProj.error) return null;
    return newProj;
  };

  const enableEditMode = async (initNewVersion, isMilestoneMode) => {
    if (initNewVersion && !isLoadingNewVersion) {
      setIsLoadingNewVersion(true);
      const newVersion = await apiInitNewVersion();
      if (newVersion) {
        history.push(`/policies/${policyId}/projs/${newVersion.id}?edit=1${isLinkedFromHistory.current ? '&isHistory=1' : ''}`);
      }
      setIsLoadingNewVersion(true);
      return;
    }
    if (isMilestoneMode){
      history.push(`/policies/${policyId}/projs/${projId}?edit=1${isMilestoneMode ? '&milestones=1' : ''}`);
      return
    }
    history.push(`/policies/${policyId}/projs/${projId}?edit=1${isLinkedFromHistory.current ? '&isHistory=1' : ''}`);
  };

  return (
    <>
      {isNewProject}
      {isCheckedLatestVersion && (isEditMode || isNewProject
        ? (
          <PolicyProjectPassportEdit
            key={projId}
            projId={projId}
            policyId={policyId}
            mngData={mngData}
            periods={periods}
            enableReadMode={(isHistory) => history.push(`/policies/${policyId}/projs/${projId}${isHistory ? '?isHistory=1' : ''}`)}
            isLatestVersion={isLatestVersion}
          />
        )
        : (
          <PolicyProjectPassportRead
            key={projId}
            projId={projId}
            policyId={policyId}
            mngData={mngData}
            enableEditMode={enableEditMode}
            isLatestVersion={isLatestVersion}
          />
        ))}
    </>
  );
}
